module.exports = __webpack_public_path__ + "static/media/bar-finished.84f457fb.jpg";